import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

import EventsConsolidate from './EventsObjectiveTablePre';
import Period from '../../../../helpers/Period';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CloseIcon from '@material-ui/icons/Close';

// Component styles
import styles from './styles';

class EventsObjective extends Component {

    constructor(props) {
        super(props);
        this.EventsConsolidateClick = this.EventsConsolidateClick.bind(this);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.state = {
            typeGraph: 0,
            period: 'w',
            namePeriod: null,
            isLastEvent: false,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: {},
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            nameGraph: [this.props.match.params.nombre_objetivo+' '],
            namePeriodPorlet: ['Última Hora', 'Último Día', 'Última Semana', 'Custom', 'Últimas 3 Horas', 'Últimos 3 Días'],
            typePeriod: 2,
        };
    }

    EventsConsolidateClick() {
        this.setState({
            typeGraph: 0,
            isLastEvent: false,
            responseTimeGraphEl: null,
        });
    }

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        if (nextPeriod === 'hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: 'Rango: última hora',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 4,
                namePeriod: 'Rango: últimas 3 horas',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: 'Rango: último día',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: 'Rango: últimos 3 días',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'semana') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: 'Rango: última semana',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'custom') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: 'Rango: ' + statePeriod.startDate.toISOString().substring(0, 10) + ' a ' + statePeriod.endDate.toISOString().substring(0, 10),
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false
            });
        }
    }


    handleFirstInfo(props) {
        let oldDate = new Date(props.x)
        let year = oldDate.getUTCFullYear()
        let month = oldDate.getUTCMonth()
        let day = oldDate.getUTCDate()
        let hours = oldDate.getUTCHours()
        let minutes = oldDate.getUTCMinutes()
        let seconds = oldDate.getUTCSeconds()
        let newDate = new Date(year, (month), day, hours, minutes, seconds)
        if (!this.state.isLastEvent && props.name !== null) {
            this.setState({
                namePeriod: props.namePeriod,
                isLastEvent: true
            })
        }
    }

    handleShowResponseTimeGraph = event => {
        this.setState({
            responseTimeGraphEl: event.currentTarget
        });
    };

    handleCloseResponseTimeGraph = () => {
        this.setState({
            responseTimeGraphEl: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) {
            this.setState({
                typeGraph: 0,
                period: this.state.period,
                isLastEvent: false,
                objetive: this.props.match.params.objetivo_id,
            })
        }
    }

    handleClose = event => {

        /*if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })*/
        this.props.onClose()
	};

    render() {
        const { classes, className, location, ...rest } = this.props;

        const { typeGraph, period,statePeriod, isStatePeriod, responseTimeGraphEl, periodEl, nameGraph, namePeriodPorlet, typePeriod } = this.state;
        let buttonEventsConsolidate;
        const showResponseTimeGraphEl = Boolean(responseTimeGraphEl);
        const showPeriodEl = Boolean(periodEl);

        buttonEventsConsolidate = <EventsConsolidatebutton onClick={this.EventsConsolidateClick} />;

        const rootClassName = classNames(classes.root, className);

        //if (!this.state.dataError) {
            return (
                <Portlet
                    style={{backgroundColor:"#656565", maxHeight: '90%'}}
                    /*  {...rest} */
                    //className={rootClassName}
                >
                    <PortletHeader className={classes.header}
                    >
                        <Typography variant="h3" style={{color:"white", paddingRight:"160px"}}>{nameGraph[typeGraph]}</Typography>
                        
                        
                        <PortletToolbar>
                            <IconButton
                                className={classes.refreshButton}
                                variant="text"
                                onClick={this.handleRefresh}
                            >
                                {/*<RefreshIcon />*/}
                            </IconButton>
                            <Button
                            style={{color:"#fff"}}
                            variant="text"
                            onClick={this.handleShowResponseTimeGraph}
                            >
                            Gráficos <ArrowRightIcon />

                        </Button>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={2}
                            xl={2}
                         >
                            <IconButton key="close" aria-label="close" style={{color:"white"}} onClick={this.handleClose}><CloseIcon/></IconButton>
                         </Grid>
                        <Popover
                            anchorEl={responseTimeGraphEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleCloseResponseTimeGraph}
                            open={showResponseTimeGraphEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <div>
                                {buttonEventsConsolidate}
                            </div>
                        </Popover>
                        </PortletToolbar>
                        
                    </PortletHeader>
                    <PortletContent style={{maxHeight: '100%', overflowY: 'auto'}}>
                        <Grid
                            container
                            spacing={32}
                        >
                            
                            <Grid
                                item
                                sm={12}
                                xl={12}
                                xs={12}>
                                <PerfectScrollbar>
                                <div >
                                    {<Graph
                                        typeGraph={typeGraph}
                                        period={period}
                                        onFirstInfo={this.handleFirstInfo}
                                        statePeriod={statePeriod}
                                        isStatePeriod={isStatePeriod} />}
                        
                                </div>
                                </PerfectScrollbar>
                            </Grid>
                            
                            
                        </Grid>     
                        
                    </PortletContent>
                    <PortletFooter className={classes.portletFooter}>
                        <Button variant="text" onClick={this.handleShowPeriod} style={{color:"white"}}>
                            {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon style={{color:"white"}}/>
                        </Button>
                        <Popover
                            anchorEl={periodEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleClosePeriod}
                            open={showPeriodEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={true}/>
                        </Popover>
                        
                    </PortletFooter>
                </Portlet>


            )
        }
        /*else if (this.state.dataError) {
            return (<p>No hay datos..</p>)
        }
        else if (this.state.isLoading) {
            return (<p>Cargando..</p>)
        }
        else if (this.state.externalData == null) {
            return (<p>Cargando..</p>)
        }
        else return (<p>Error!</p>)
    }*/
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        return <EventsConsolidate params={props} />;
    }
}

function EventsConsolidatebutton(props) {
    return (
        <Button variant="text" onClick={props.onClick}>
            Eventos Consolidados
      </Button>
    );
}

export default
    compose(withRouter, withStyles(styles))(EventsObjective);